import styled from 'styled-components';

export const WrapperProjects = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: 100%;
  min-height: 150px;
`;

export const ProjectDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 74px;
  margin: 10px 5px 5px 0;
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  background-color: ${({ theme }) => {
    return theme.colors.white;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  div {
    display: flex;
    justify-content: space-between;
  }
  h3 {
    border-bottom: ${({ theme }) => {
      return theme.border;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
  }
  h3,
  p {
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    margin: 5px;
  }
  button {
    box-sizing: border-box;
    margin-right: 5px;
    background-color: ${({ theme }) => {
      return theme.colors.backgroundForm;
    }};
    border: 1px solid
      ${({ theme }) => {
        return theme.colors.error;
      }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.superSmall;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    color: ${({ theme }) => {
      return theme.colors.error;
    }};
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.error;
      }};
      color: ${({ theme }) => {
        return theme.colors.backgroundForm;
      }};
    }
  }
`;
